import RatingsInputSdk from '@wix/thunderbolt-elements/src/components/RatingsInput/corvid/RatingsInput.corvid';


const RatingsInput = {
  sdk: RatingsInputSdk
};


export const components = {
  ['RatingsInput']: RatingsInput
};

